import { SORT_ARGS } from "../training-const";
import {SortingModelAbstract} from "@/models/SortingModelAbstract";

export default class TrainingSortModel extends SortingModelAbstract  {
  constructor(query) {
    super(SORT_ARGS);

    this.by = []
    this.desc = []
    this.ordering = null
    this._apiAttributes = {
      name: SORT_ARGS.NAME,
      category: SORT_ARGS.CATEGORY,
    }
    this._customSorting = {
    }
    this._orderingFields = {
      [SORT_ARGS.NAME]: 'name',
      [SORT_ARGS.CATEGORY]: 'category',
    }
    this._initByQuery(query)

  }
}
